<div class="flex flex-wrap gap-2">
  <app-filter-pill
    *ngFor="let filter of activeFilters$ | async; trackBy: trackBy"
    [label]="filter"
    (dismissClicked)="removeFilter(filter)">
  </app-filter-pill>
</div>
